export const simulation: SimulationSetup = {
    allocation: {
        adjacent: 0.5,
        core: 0.5,
        disruptive: 0,
        step: 0.1,
    },
    colors: ['transparent', '#FF0000', '#FFBF00', '#FEFF00', '#00B050', '#FEFF00', '#FFBF00', '#FF0000'],
    content: {
        cta: {
            buttonLabel: 'Try Krobar.ai free',
            buttonLink: 'https://krobar.ai',
            image: '/assets/images/krobar-hurricane-chart.png',
            title: 'Found the right portfolio mix? Build the business case in minutes.',
            text: 'Krobar helps you forecast portfolio impact, model downside risk, and present stakeholder-ready decisions.',
        },
        graph: {
            x: 'Time',
            y: 'Revenue',
        },
        results: {
            failure: 'Chance of Bankruptcy',
            low: 'When the level of risk is LOW, you have almost no chance of bankruptcy.\n\n50%-50%-0% invests all of your resources in the primary business and new opportunities without investing anything in transformation.\n\nBut will that portfolio mix still deliver revenue when the environmental risk becomes MEDIUM?',
            medium: "When the level of risk is MEDIUM, there are significant risks.\n\n50%-50%-0% doesn't allow for significant changes in the environment that might result in bankruptcy.\n\nBut what happens when the environmental risk becomes HIGH?",
            high: 'When the risk in the environment is HIGH, only investing in the core business is dangerous. A single event (like Covid or supply chain disruptions) can leave us at a critical disadvantage to our competition.\n\nA portfolio mix of 50%-50%-0% will _eventually_ result in *bankruptcy*.\n\nTo achieve long term success, we must invest resources in the core business, adjacent opportunities, and longshot transformational projects.',
        },
    },
    legend: ['Highly unlikely', 'Unlikely', 'Possible', 'Likely'],
    options: {
        animation: false,
        layout: {
            padding: {
                right: 1,
                top: 1,
            },
        },
        radius: 0,
        responsive: true,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    display: false,
                },
                title: {
                    display: true,
                },
            },
            y: {
                grid: {
                    drawTicks: false,
                },
                suggestedMax: 5000,
                ticks: {
                    autoSkip: false,
                    display: false,
                    stepSize: 1000,
                },
                title: {
                    display: true,
                },
            },
        },
    },
};
